module.exports = __webpack_public_path__ + "static/img/franche-compte.3ee3671a.jpg";